import { useSendToLenders, useConditionsContext } from "./ConditionsDialog";
import { AlertCircle } from "lucide-react";
import ExistingConditionUpload from "./ExistingConditionUpload";
import NewConditionUpload from "./NewConditionUpload";
import { isPorchpassLender } from "src/utils/conditionUtils";

export default function UploadDocumentStep() {
  const { lenders, selectedLenderIndices } = useSendToLenders();
  const { conditions, loadingConditions } = useConditionsContext();

  // Check if only porchpass is selected
  const isOnlyPorchpass =
    selectedLenderIndices.length === 1 &&
    isPorchpassLender(lenders[selectedLenderIndices[0]]);

  // When only Porchpass is selected, show existing conditions upload + new conditions
  if (isOnlyPorchpass) {
    return (
      <div>
        <ExistingConditionUpload
          conditions={conditions}
          isLoading={loadingConditions}
          stepNumber={2}
        />
        <NewConditionUpload stepNumber={3} />
      </div>
    );
  }

  // Upload UI for non-Porchpass lenders.
  // Currently, only Porchpass conditions are fully supported for sending.
  return (
    <div>
      {/* Disclaimer for non-Porchpass lenders */}
      <div className="mb-4 p-3 bg-yellow-50 border border-yellow-200 rounded text-sm text-yellow-800 flex items-start gap-2">
        <AlertCircle size={16} className="flex-shrink-0 mt-0.5" />
        <span>
          Only sending conditions to Porchpass is currently supported.
        </span>
      </div>

      <p className="text-sm font-normal text-[#4A5466] mb-4">
        Prepare documents with titles and descriptions.
      </p>
      <NewConditionUpload stepNumber={2} />
    </div>
  );
}
